import { render, staticRenderFns } from "./CarouselMenu.vue?vue&type=template&id=eac892c4&scoped=true"
import script from "./CarouselMenu.vue?vue&type=script&lang=js"
export * from "./CarouselMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eac892c4",
  null
  
)

export default component.exports